export default function getUsersPosition(users, quizMarks, assignmentsMarks) {
  const usersTotalMarks = users?.map((user) => {
    const usersQuizMarks = quizMarks?.filter((mark) => {
      return mark.student_id === user.id;
    });
    const usersAssignmentMarks = assignmentsMarks?.filter((mark) => {
      return mark.student_id === user.id;
    });
    const quizMark = usersQuizMarks?.reduce((prevMark, mark) => {
      return prevMark + mark.mark;
    }, 0);
    const assignmentMark = usersAssignmentMarks?.reduce((prevMark, mark) => {
      return prevMark + mark.mark;
    }, 0);
    const totalMark = (quizMark + assignmentMark).toString();
    return { ...user, totalMark, quizMark, assignmentMark };
  });
  usersTotalMarks?.sort((a, b) => b.totalMark - a.totalMark);

  // loop through the sorted array and add the position property to each object
  const usersPosition = usersTotalMarks?.map((user, index) => {
    const position = index + 1;
    user.position = usersTotalMarks[index - 1]
      ? usersTotalMarks[index - 1]?.position + 1
      : position;

    // check if the previous user has the same totalMark as the current user
    if (index > 0 && usersTotalMarks[index - 1].totalMark === user.totalMark) {
      // if yes, set the position of the current user to the same position as the previous user
      user.position = usersTotalMarks[index - 1].position;
    }
    return user;
  });

  return usersPosition;
}
